import React, { Component, Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import { interviewAvailabilityShape } from '../../../dateUtils';
import { isMobile } from '../../../screenUtils';
import capitalize from '../../../stringUtils';
import InterviewCardOverlay from './InterviewCardOverlay';
import './Interview.scss';

class Interview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCard: false,
      overlayPlacement: 'right',
    };

    this.listItemRef = createRef();
    this.overlayContainerRef = createRef();
    this.editModalRef = null;
    this.rescheduleModalRef = null;
    this.setEditModalRef = this.setEditModalRef.bind(this);
    this.setResheduleModalRef = this.setResheduleModalRef.bind(this);
    this.handleOverlayClose = this.handleOverlayClose.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.renderDateAndTime = this.renderDateAndTime.bind(this);
    this.renderTypeBadge = this.renderTypeBadge.bind(this);
    this.renderDurationAndGuests = this.renderDurationAndGuests.bind(this);
    this.renderUpcoming = this.renderUpcoming.bind(this);
    this.renderPast = this.renderPast.bind(this);
    this.renderPending = this.renderPending.bind(this);
    this.renderReschedule = this.renderReschedule.bind(this);
    this.render = this.render.bind(this);

    this.renderInterviewFuncMapping = {
      upcoming: this.renderUpcoming,
      past: this.renderPast,
      pending: this.renderPending,
      reschedule: this.renderReschedule,
    };
  }

  componentDidMount() {
    this.updateOverlayPlacement();
    window.addEventListener('resize', this.updateOverlayPlacement);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateOverlayPlacement);
  }

  updateOverlayPlacement = () => {
    const onMobile = window.innerWidth <= 768;
    this.setState({ overlayPlacement: onMobile ? 'top' : 'right' });
  };

  setEditModalRef(el) {
    this.editModalRef = el;
  }

  setResheduleModalRef(el) {
    this.rescheduleModalRef = el;
  }

  handleOverlayClose() {
    if (
      (this.editModalRef && this.editModalRef.isModalOpen?.())
      || (this.rescheduleModalRef && this.rescheduleModalRef.isModalOpen?.())
    ) {
      return;
    }

    this.setState({ showCard: false });
  }

  handleClick() {
    const { consultantView, interviewType } = this.props;
    if (!(consultantView && interviewType === 'pending')) {
      this.setState((prevState) => ({ showCard: !prevState.showCard }));
    }
  }

  renderDateAndTime() {
    const { interview } = this.props;
    if (!interview.accepted_time) return null;

    const dateStr = interview.accepted_time.date;
    const date = new Date(dateStr);
    const month = date.toLocaleString('default', { timeZone: 'UTC', month: 'short' });
    const day = date.getUTCDate();
    const timeAndDateStr = `${dateStr} ${interview.accepted_time.start_time}`;
    const m = moment(timeAndDateStr);

    return (
      <div className="date-and-time">
        <div className="date">
          <h2 className="medium-weight">{day}</h2>
          <div className="normal-weight interview-month">{month}</div>
        </div>
        <div className="time ms-3">
          <h2 className="normal-weight">
            {m.format('hh:mm')}
            <span>{m.format('A')}</span>
          </h2>
          {this.renderDurationAndGuests()}
        </div>
      </div>
    );
  }

  renderTypeBadge() {
    return (
      <div className="interview-type-badge body-text-4">
        {capitalize(this.props.interviewType)}
      </div>
    );
  }

  renderDurationAndGuests() {
    const { attendees, slot_duration_minutes } = this.props.interview;
    let numGuests = attendees.invitees.length;
    if (attendees.consultant) numGuests += 1;
    if (attendees.requester) numGuests += 1;

    return (
      <div className="guests-count normal-weight">
        {slot_duration_minutes}
        {' '}
        mins&nbsp;&#183;&nbsp;
        {numGuests}
        {' '}
        guests
      </div>
    );
  }

  renderUpcoming() {
    return (
      <Fragment>
        <div className="left-side">{this.renderDateAndTime()}</div>
        <div className="right-side">{this.renderTypeBadge()}</div>
      </Fragment>
    );
  }

  renderPast() {
    return this.renderUpcoming();
  }

  renderReschedule() {
    return (
      <Fragment>
        <div className="left-side">
          <div className="body-text-2 medium-weight mb-4">
            <span>
              <i className="fas fa-bell" />
              Reschedule Requested
            </span>
          </div>
          {this.renderDurationAndGuests()}
        </div>
        <div className="right-side">{this.renderTypeBadge()}</div>
      </Fragment>
    );
  }

  renderPending() {
    const { consultantView, consultantInterviewPath, interview } = this.props;
    return (
      <Fragment>
        <div className="left-side">
          <div className="body-text-2 medium-weight mb-4">
            {consultantView ? (
              <span>
                <i className="fas fa-bell" />
                &nbsp;Book Pending Interview&nbsp;
                <a href={`${consultantInterviewPath}?interview_id=${interview.resource_id}`}>here</a>
              </span>
            ) : (
              <span>Interview pending confirmation</span>
            )}
          </div>
          {this.renderDurationAndGuests()}
        </div>
        <div className="right-side">{this.renderTypeBadge()}</div>
      </Fragment>
    );
  }

  render() {
    const {
      interviewType,
      consultantView,
      repOrOwner,
      newInterviewSlot,
      availableInterviewSlotUrl,
      interview,
      possibleInterviewers,
      invitableRoles,
      csrfToken,
      onCancel,
      onSubmitMeetingDetails,
      canCancel,
      canEdit,
      isRep,
    } = this.props;

    const renderInterview = this.renderInterviewFuncMapping[interviewType];
    const { overlayPlacement, showCard } = this.state;
    return (
      <div className="interview-overlay-container" style={{ position: 'relative' }} ref={this.overlayContainerRef}>
        <div
          className={`interview-container ${interviewType} ${consultantView ? 'consultant-view' : ''}`}
          id={interview.id}
          ref={this.listItemRef}
          role="button"
          tabIndex="0"
          onClick={this.handleClick}
        >
          <div className={`interview-body ${interviewType}`}>{renderInterview()}</div>
        </div>

        <Overlay
          show={showCard}
          onHide={this.handleOverlayClose}
          target={() => this.listItemRef.current}
          container={() => this.overlayContainerRef.current}
          placement={overlayPlacement}
          containerPadding={20}
          rootClose
        >
          <Popover id="popover-basic" className="overlay-behind-modal">
            <Popover.Body>
              <InterviewCardOverlay
                interview={interview}
                interviewType={interviewType}
                possibleInterviewers={possibleInterviewers}
                invitableRoles={invitableRoles}
                csrfToken={csrfToken}
                onCancel={onCancel}
                onSubmitMeetingDetails={onSubmitMeetingDetails}
                canCancel={canCancel}
                canEdit={canEdit}
                consultantView={consultantView}
                closeOverlay={this.handleOverlayClose}
                isRep={isRep}
                editModalRef={this.setEditModalRef}
                resheduleModalRef={this.setResheduleModalRef}
                repOrOwner={repOrOwner}
                newInterviewSlot={newInterviewSlot}
                availableInterviewSlotUrl={availableInterviewSlotUrl}
              />
            </Popover.Body>
          </Popover>
        </Overlay>
      </div>
    );
  }
}

Interview.propTypes = {
  interviewType: PropTypes.oneOf(['upcoming', 'pending', 'past', 'reschedule']).isRequired,
  interview: PropTypes.shape({
    accepted_time: interviewAvailabilityShape,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
      requester: PropTypes.string,
    }).isRequired,
    availabilities: PropTypes.arrayOf(interviewAvailabilityShape),
    timezone: PropTypes.string.isRequired,
    slot_duration_minutes: PropTypes.number.isRequired,
    round_number: PropTypes.number,
    id: PropTypes.number.isRequired,
    edit_interview_path: PropTypes.string,
    cancel_interview_path: PropTypes.string,
    resource_id: PropTypes.string.isRequired,
  }).isRequired,
  possibleInterviewers: PropTypes.shape({}),
  invitableRoles: PropTypes.arrayOf(PropTypes.string),
  onCancel: PropTypes.func,
  onSubmitMeetingDetails: PropTypes.func,
  isRep: PropTypes.bool,
  canCancel: PropTypes.bool,
  canEdit: PropTypes.bool,
  consultantView: PropTypes.bool,
  repOrOwner: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  consultantInterviewPath: PropTypes.string,
  newInterviewSlot: PropTypes.bool,
  availableInterviewSlotUrl: PropTypes.string.isRequired,

};

Interview.defaultProps = {
  possibleInterviewers: [],
  invitableRoles: [],
  onCancel: () => null,
  onSubmitMeetingDetails: () => null,
  isRep: false,
  consultantView: false,
  canEdit: false,
  canCancel: false,
  repOrOwner: false,
  consultantInterviewPath: '',
  newInterviewSlot: false,
};

export default Interview;
